// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TransferFunds_beneficiary__h8Ot0 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 38rem;
  margin-bottom: 3rem;
  cursor: pointer;
}
.TransferFunds_beneficiary__h8Ot0 > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.TransferFunds_beneficiary__saved__cnv9a {
  background-color: var(--color-fash-primary-3);
  color: var(--color-white);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.TransferFunds_beneficiary__saved_b__qC9YW {
  border: 1px solid var(--color-fash-primary-3);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.TransferFunds_beneficiary__new__9Npdo {
  border: 1px solid var(--color-fash-primary-3);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}
.TransferFunds_beneficiary__new_b__geYNQ {
  background-color: var(--color-fash-primary-3);
  color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}

.TransferFunds_pin__FZRRZ {
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
  padding-left: 2rem;
}
.TransferFunds_pin__label__zoAkO {
  font-size: var(--default-font-small);
  font-family: inherit;
  padding-left: 4rem;
}
.TransferFunds_pin__group__xjrke {
  margin-top: 2rem;
}

.TransferFunds_centerContent__0o4rQ {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.TransferFunds_confirmImage__vuED3 {
  width: 20rem;
  margin-bottom: 5rem;
}

.TransferFunds_transferSuccessImg__rlYd- {
  width: 30rem;
  margin-bottom: 5rem;
}

.TransferFunds_transferFailedImg__63Gz6 {
  width: 20rem;
  margin-bottom: 5rem;
}

.TransferFunds_buttonBeside__XPe5I {
  display: flex;
  gap: 3rem;
  align-items: center;
}

.TransferFunds_beneficiaries__t9QsI {
  display: flex;
  align-items: center;
  width: 38rem;
}
.TransferFunds_beneficiaries__t9QsI > :not(:last-child) {
  margin-right: 1rem;
}
.TransferFunds_beneficiaries__details__sU\\+fw {
  width: 33rem;
  cursor: pointer;
}
.TransferFunds_beneficiaries__details__bank__l3DGB {
  text-transform: uppercase;
  font-size: var(--default-font-small);
}
.TransferFunds_beneficiaries__details__sU\\+fw:hover {
  color: var(--color-fash-primary-3);
  font-weight: 700;
}
.TransferFunds_beneficiaries__delete__iQUZ0 {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: var(--color-error);
  cursor: pointer;
  font-size: 3rem;
}
.TransferFunds_beneficiaries__delete__iQUZ0:hover {
  font-weight: 700;
}
.TransferFunds_beneficiaries__delete__iQUZ0 p {
  font-size: 1.4rem;
  color: var(--color-deep-red);
}

.TransferFunds_line__yqjm4 {
  margin: 1rem 0;
  border-top: 1px solid var(--color-primary);
}

.TransferFunds_bankList__KWIGd {
  width: 38rem;
  cursor: pointer;
}
.TransferFunds_bankList__KWIGd:not(:last-child) {
  margin-bottom: 2rem;
}
.TransferFunds_bankList__KWIGd:hover {
  color: var(--color-primary);
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Wallet/TransferFunds.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EAEA,mBAAA;EACA,eAAA;AAAF;AAEE;EACE,sBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,6CAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AADJ;AAGI;EACE,6CAAA;EACA,4BAAA;EACA,oBAAA;AADN;AAKE;EACE,6CAAA;EACA,4BAAA;EACA,oBAAA;AAHJ;AAKI;EACE,6CAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAHN;;AASA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AANF;AAQE;EACE,oCAAA;EACA,oBAAA;EACA,kBAAA;AANJ;AASE;EACE,gBAAA;AAPJ;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AARF;;AAUA;EACE,YAAA;EACA,mBAAA;AAPF;;AAUA;EACE,YAAA;EACA,mBAAA;AAPF;;AAUA;EACE,YAAA;EACA,mBAAA;AAPF;;AAUA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAPF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AARF;AASE;EACE,kBAAA;AAPJ;AAUE;EACE,YAAA;EACA,eAAA;AARJ;AAUI;EACE,yBAAA;EACA,oCAAA;AARN;AAWI;EACE,kCAAA;EACA,gBAAA;AATN;AAaE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;AAXJ;AAaI;EACE,gBAAA;AAXN;AAcI;EACE,iBAAA;EACA,4BAAA;AAZN;;AAiBA;EACE,cAAA;EACA,0CAAA;AAdF;;AAgBA;EACE,YAAA;EACA,eAAA;AAbF;AAcE;EACE,mBAAA;AAZJ;AAeE;EACE,2BAAA;EACA,gBAAA;AAbJ","sourcesContent":[".beneficiary {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  box-sizing: border-box;\n  font-size: var(--default-font-small);\n  width: 38rem;\n\n  margin-bottom: 3rem;\n  cursor: pointer;\n\n  & > * {\n    padding: 1rem 0 1rem 0;\n    text-align: center;\n  }\n\n  &__saved {\n    background-color: var(--color-fash-primary-3);\n    color: var(--color-white);\n    border-radius: 1rem 0 0 1rem;\n    transition: all 0.4s;\n\n    &_b {\n      border: 1px solid var(--color-fash-primary-3);\n      border-radius: 1rem 0 0 1rem;\n      transition: all 0.4s;\n    }\n  }\n\n  &__new {\n    border: 1px solid var(--color-fash-primary-3);\n    border-radius: 0 1rem 1rem 0;\n    transition: all 0.4s;\n\n    &_b {\n      background-color: var(--color-fash-primary-3);\n      color: var(--color-white);\n      border-radius: 0 1rem 1rem 0;\n      transition: all 0.4s;\n    }\n  }\n}\n\n//Pin styles\n.pin {\n  display: flex;\n  gap: 2rem;\n  margin-top: 1rem;\n  padding-left: 2rem;\n\n  &__label {\n    font-size: var(--default-font-small);\n    font-family: inherit;\n    padding-left: 4rem;\n  }\n\n  &__group {\n    margin-top: 2rem;\n  }\n}\n\n.centerContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.confirmImage {\n  width: 20rem;\n  margin-bottom: 5rem;\n}\n\n.transferSuccessImg {\n  width: 30rem;\n  margin-bottom: 5rem;\n}\n\n.transferFailedImg {\n  width: 20rem;\n  margin-bottom: 5rem;\n}\n\n.buttonBeside {\n  display: flex;\n  gap: 3rem;\n  align-items: center;\n}\n\n//Beneficiaries\n.beneficiaries {\n  display: flex;\n  align-items: center;\n  width: 38rem;\n  & > :not(:last-child) {\n    margin-right: 1rem;\n  }\n\n  &__details {\n    width: 33rem;\n    cursor: pointer;\n\n    &__bank {\n      text-transform: uppercase;\n      font-size: var(--default-font-small);\n    }\n\n    &:hover {\n      color: var(--color-fash-primary-3);\n      font-weight: 700;\n    }\n  }\n\n  &__delete {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    color: var(--color-error);\n    cursor: pointer;\n    font-size: 3rem;\n\n    &:hover {\n      font-weight: 700;\n    }\n\n    p {\n      font-size: 1.4rem;\n      color: var(--color-deep-red);\n    }\n  }\n}\n\n.line {\n  margin: 1rem 0;\n  border-top: 1px solid var(--color-primary);\n}\n.bankList {\n  width: 38rem;\n  cursor: pointer;\n  &:not(:last-child) {\n    margin-bottom: 2rem;\n  }\n\n  &:hover {\n    color: var(--color-primary);\n    font-weight: 700;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"beneficiary": `TransferFunds_beneficiary__h8Ot0`,
	"beneficiary__saved": `TransferFunds_beneficiary__saved__cnv9a`,
	"beneficiary__saved_b": `TransferFunds_beneficiary__saved_b__qC9YW`,
	"beneficiary__new": `TransferFunds_beneficiary__new__9Npdo`,
	"beneficiary__new_b": `TransferFunds_beneficiary__new_b__geYNQ`,
	"pin": `TransferFunds_pin__FZRRZ`,
	"pin__label": `TransferFunds_pin__label__zoAkO`,
	"pin__group": `TransferFunds_pin__group__xjrke`,
	"centerContent": `TransferFunds_centerContent__0o4rQ`,
	"confirmImage": `TransferFunds_confirmImage__vuED3`,
	"transferSuccessImg": `TransferFunds_transferSuccessImg__rlYd-`,
	"transferFailedImg": `TransferFunds_transferFailedImg__63Gz6`,
	"buttonBeside": `TransferFunds_buttonBeside__XPe5I`,
	"beneficiaries": `TransferFunds_beneficiaries__t9QsI`,
	"beneficiaries__details": `TransferFunds_beneficiaries__details__sU+fw`,
	"beneficiaries__details__bank": `TransferFunds_beneficiaries__details__bank__l3DGB`,
	"beneficiaries__delete": `TransferFunds_beneficiaries__delete__iQUZ0`,
	"line": `TransferFunds_line__yqjm4`,
	"bankList": `TransferFunds_bankList__KWIGd`
};
export default ___CSS_LOADER_EXPORT___;
